import styled, { css } from 'styled-components';
import { getWhiteColor } from '../../../foundation/theme/palette.utils';
import { getSpace } from '../../../foundation/theme/space.utils';
import tokens from '../../../foundation/tokens/js/tokens';
import { FIELDSET_BODY_PADDING_SIZES } from './Fieldset.constants';
// styled-components.
// -----------------------------------------------------------------------------
export const FieldsetRoot = styled.div `
  ${({ variant }) => {
    return css `
      /* Fixed
      ----------- */
      margin: 0 0 ${getSpace('xl')} 0;

      fieldset {
        border: 0;
        margin: 0;
        padding: 0;
      }

      /* Variants
      ----------- */
      ${variant === 'box' &&
        css `
        background-color: ${getWhiteColor()};
        border: 1px solid ${tokens.colors.midnight[200].value};
        border-radius: ${tokens.radius.m};
      `}

      ${variant === 'underline' &&
        css `
        border: 0;
      `}
    `;
}}
`;
export const FieldsetLegend = styled.legend `
  ${({ theme, variant }) => {
    return css `
      /* Fixed
      ----------- */
      border-top-left-radius: ${tokens.radius.m};
      border-top-right-radius: ${tokens.radius.m};
      box-sizing: border-box;
      color: ${theme.palette.text.subtle};
      display: flex;
      align-items: center;
      margin: 0;
      width: 100%;
      gap: 1rem;

      /* Variants
      ----------- */
      ${variant === 'box' &&
        css `
        background-color: ${tokens.colors.midnight[100].value};
        border-bottom: 1px solid ${tokens.colors.midnight[200].value};

        padding-bottom: ${getSpace('l')};
        padding-left: ${getSpace('2xl')};
        padding-top: ${getSpace('l')};
        padding-right: ${getSpace('2xl')};
      `}

      ${variant === 'underline' &&
        css `
        border-bottom: 1px solid ${tokens.colors.midnight[200].value};
        padding: 0 0 ${getSpace('m')} 0;
      `}
    `;
}}
`;
export const FieldsetLegendText = styled.span `
  flex: 1 1 auto;
`;
export const FieldsetLegendActionsSlot = styled.span `
  flex: 0 1 auto;
`;
export const FieldsetBody = styled.div `
  ${({ variant }) => {
    const verticalPadding = getSpace(FIELDSET_BODY_PADDING_SIZES[variant].vertical);
    const horizontalPadding = getSpace(FIELDSET_BODY_PADDING_SIZES[variant].horizontal);
    return css `
      padding-bottom: ${verticalPadding};
      padding-right: ${horizontalPadding};
      padding-top: ${verticalPadding};
      padding-left: ${horizontalPadding};
      position: relative;
    `;
}}
`;
export const LockedOverlay = styled.div `
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  background: rgba(0, 0, 0, 0.05);
  background: linear-gradient(
    0,
    rgba(2, 0, 36, 0.1) 0%,
    rgba(2, 0, 36, 0.05) 50%,
    rgba(2, 0, 36, 0.025) 100%
  );
  border-radius: 0 0 ${tokens.radius.m} ${tokens.radius.m};
  cursor: not-allowed;
`;
//# sourceMappingURL=Fieldset.styled.js.map